<div class="{{ 'accordion ' + className }}" id="accordion">
	<ng-content></ng-content>
</div>
